<template>
  <div class="my-6 w-full">
    <a class="flex w-fit cursor-pointer items-center gap-2 font-medium text-theme-1" :href="backLink">
      <img class="rotate-90" :src="Icons.ArrowDown.src" />

      <span>{{ $t("common.back") }}</span>
    </a>
  </div>

  <ProfileHeader v-if="mobile_or_desktop === 'desktop'" :profile="profile" :slug="slug" />

  <ProfileHeaderMobile v-else :profile="profile" :slug="slug" />

  <ProfileDetails :profile="profile" />

  <ProfilePreviewGallery
    :gallery="profile.gallery"
    :original-gallery="profile.gallery_originals"
    :bundle-name="profile.name"
    client:only
  />

  <div v-if="recommendationsData?.profiles.length" class="mt-10 md:mt-16">
    <h2 class="mb-3 font-medium md:text-lg">
      {{ $t("pages.profile-shop.profile-page.recommendations.title") }}
    </h2>

    <ProfileGrid
      class="mb-10"
      :profiles="recommendationsProfiles"
      :is-loading="isRecommendationsLoading"
      :skeleton-count="6"
      selected-compare-style-image="original"
      source="profile_page_similar"
      :scrollable="mobile_or_desktop === 'desktop'"
    />
  </div>
</template>

<script setup lang="ts">
import { IBundleDetailesResponse } from "@/features/sell-a-profile/services/api";
import ProfileHeader from "./ProfileHeader.vue";
import ProfileHeaderMobile from "./ProfileHeaderMobile.vue";
import ProfileDetails from "./ProfileDetails.vue";
import { Icons } from "@/core-ui-vue";
import { universalStorage } from "@/utils/universal-storage";
import ProfilePreviewGallery from "@/features/sell-a-profile/components/bundle-details/ProfilePreviewGallery.vue";
import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
import { profileRecommendationsQueryOptions } from "@/features/profile-shop/services/api";
import ProfileGrid from "@/features/profile-shop/components/profileGrid/ProfileGrid.vue";

const props = defineProps<{
  profile: IBundleDetailesResponse;
  slug: string;
  backLink: string;
}>();

const mobile_or_desktop = universalStorage.get("mobile_or_desktop");

const recommendationsQuery = computed(() => ({
  type: "bundle" as const,
  bundle_id: props.profile.id,
}));

const { data: recommendationsData, isLoading: isRecommendationsLoading } = useQuery(
  profileRecommendationsQueryOptions(recommendationsQuery)
);

const recommendationsProfiles = computed(() => {
  return mobile_or_desktop === "desktop"
    ? recommendationsData.value?.profiles
    : recommendationsData.value?.profiles?.slice(0, 3);
});
</script>

<style>
html {
  font-size: 16px !important;
}
</style>
